import { HardHat } from 'lucide-react';
import { scafState } from '../lib/inspect';

// scaffold traffic light on the start screen (building mode): red overdue, yellow ≤ 7 days, green running
export default function ScaffoldBanner({ t, project }) {
  const rs = (project.scaffolds || []).map(scafState).filter((r) => ['red', 'yellow', 'green'].includes(r.st));
  if (!rs.length) return null;
  const n = (k) => rs.filter((r) => r.st === k).length;
  const lv = n('red') ? 'red' : n('yellow') ? 'yellow' : 'green';
  const go = () => document.querySelector('[data-testid="scaffold-box"]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  return (
    <button className={`sc-banner sc-banner-${lv}`} data-testid="scaffold-banner" onClick={go}>
      <HardHat size={16} />
      <b>{t.sbTitle}</b>
      <span data-testid="scaffold-banner-counts">🔴 {n('red')} · 🟡 {n('yellow')} · 🟢 {n('green')}</span>
      <small>{t.sbShow} ›</small>
    </button>
  );
}
